import React from "react";
import { List } from "antd";
import Item from "./Item";
import "./operational.css";

const TITLES = {
  AmbulanceView: "Скорая помощь",
  PoliceView: "Полиция",
  EmergencyDepartmentView: "МЧС",
};

const Lists = (props) => {
  const { dataSource, code } = props;

  return (
    <div className="list-wrapper">
      <h3 className="list-title">{TITLES[code] || code}</h3>
      <List
        itemLayout="horizontal"
        pagination={dataSource.length > 0 ? { pageSize: 5 } : false}
        size="large"
        dataSource={dataSource}
        renderItem={(item) => <Item item={item} code={code} />}
      />
    </div>
  );
};

export default Lists;
